/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import closeIcon from '../../../../assets/images/x_icon_black.svg';

import './index.scss';
import moment from 'moment';

Modal.setAppElement('#root');

class DeleteReminderModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillReceiveProps(nextProps) {}

  componentDidMount() {}

  render() {
    const {
      modelopen,
      closeServiceModal,
      deleteReminder,
      appointmentreminder,
    } = this.props;
    const { deleteloading, deletesuccess } = appointmentreminder;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeServiceModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title">Are you sure?</div>
              <button className="modal-close" onClick={closeServiceModal}>
                <img src={closeIcon}></img>
              </button>
              <div className="modal-description">
                You are about to delete a reminder schedule. This cannot be
                undone.
              </div>
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  onClick={deleteReminder}
                  disabled={deleteloading}
                >
                  {deleteloading ? 'DELETING...' : 'DELETE'}
                </button>
                <button
                  className="btn btn--secondary btn--lg"
                  onClick={closeServiceModal}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default DeleteReminderModal;
